import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Injector,
  Type,
  ViewRef,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicComponentFactory {
  constructor(
    private app: ApplicationRef,
    private resolver: ComponentFactoryResolver,
    private injector: Injector
  ) {}

  create<T>(
    component: Type<T>,
    rootSelectorOrNode: string | any,
    projectableNodes: any[][] = []
  ): ComponentRef<T> {
    const factory = this.resolver.resolveComponentFactory(component);
    const createdComponent = factory.create(this.injector, projectableNodes, rootSelectorOrNode);

    this.app.attachView(createdComponent.hostView);

    return createdComponent;
  }

  detach(viewRef: ViewRef) {
    this.app.detachView(viewRef);
  }
}
